var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityFinance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "growth",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.725,
    height: 34.915,
    viewBox: "0 0 38.725 34.915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45607",
    "data-name": "Group 45607",
    transform: "translate(3.749 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52903",
    "data-name": "Path 52903",
    d: "M49.567,446.8l2.782.681,2.782-.681v-1.364l-2.782-.681-2.782.681Z",
    transform: "translate(-49.567 -413.018)",
    fill: "#f9cf58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52904",
    "data-name": "Path 52904",
    d: "M162.67,446.8l2.782.681,2.782-.681v-1.364l-2.782-.681-2.782.681Z",
    transform: "translate(-154.115 -413.018)",
    fill: "#ffac3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52905",
    "data-name": "Path 52905",
    d: "M275.774,446.8l2.782.681,2.782-.681v-1.364l-2.782-.681-2.782.681Z",
    transform: "translate(-258.665 -413.018)",
    fill: "#82d361"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52906",
    "data-name": "Path 52906",
    d: "M388.877,446.8l2.782.681,2.782-.681v-1.364l-2.782-.681-2.782.681Z",
    transform: "translate(-363.213 -413.018)",
    fill: "#6cc4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52907",
    "data-name": "Path 52907",
    d: "M55.13,377.227H49.567v-5.5a.758.758,0,0,1,.758-.758h4.048a.758.758,0,0,1,.758.758v5.5Z",
    transform: "translate(-49.567 -344.812)",
    fill: "#ffe27a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52908",
    "data-name": "Path 52908",
    d: "M168.233,326.675H162.67v-9.64a.758.758,0,0,1,.758-.758h4.048a.758.758,0,0,1,.758.758Z",
    transform: "translate(-154.115 -294.26)",
    fill: "#ffba57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52909",
    "data-name": "Path 52909",
    d: "M281.337,276.122h-5.563V262.346a.758.758,0,0,1,.758-.758h4.048a.758.758,0,0,1,.758.758v13.776Z",
    transform: "translate(-258.665 -243.708)",
    fill: "#98db7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52910",
    "data-name": "Path 52910",
    d: "M394.44,225.569h-5.563V207.657a.758.758,0,0,1,.758-.758h4.048a.758.758,0,0,1,.758.758v17.913Z",
    transform: "translate(-363.213 -193.155)",
    fill: "#8bcaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52911",
    "data-name": "Path 52911",
    d: "M103.627,32.175l-.668-6.65a.379.379,0,0,0-.473-.329l-6.473,1.686a.379.379,0,0,0-.121.678l1.691,1.176s-4.336,8.457-20,13.292v.423c4.3.024,15.537-1.206,22.585-10.677l1.177-.425,1.692,1.176A.379.379,0,0,0,103.627,32.175Z",
    transform: "translate(-75.461 -25.183)",
    fill: "#ff4755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45606",
    "data-name": "Group 45606",
    transform: "translate(1.621 5.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45605",
    "data-name": "Group 45605"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45604",
    "data-name": "Group 45604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52912",
    "data-name": "Path 52912",
    d: "M94.574,99.5a.38.38,0,0,0-.524.085c-7.048,9.471-16.09,10.663-22.3,11.1a.763.763,0,0,1-.252-.023l-.006,0a.71.71,0,0,0,.261,1.385c6.278-.437,16.642-2.679,23.5-12.065Z",
    transform: "translate(-70.992 -99.43)",
    fill: "#fc2b3a"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_52913",
    "data-name": "Path 52913",
    d: "M38.157,472.924H.568a.568.568,0,1,1,0-1.137H38.157a.568.568,0,1,1,0,1.137Z",
    transform: "translate(0 -438.009)",
    fill: "#407093"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityFinance);
export default __webpack_public_path__ + "static/media/university-finance.deb2e4c6036b94a315bb6f239a0c5130.svg";
export { ForwardRef as ReactComponent };